module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-08.8c427b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-08.jpg
// module id = rQ5B
// module chunks = 1